export default __webpack_public_path__ + "static/media/blocto_icon.6948814e.png";